export default __webpack_public_path__ + "static/media/Invertar.470b14d9.jpg";